// Browser stand-in for node:net — raw sockets (used for IPC with helper
// processes) are fused off in the web build.
const { EventEmitter } = require("events");

class SocketShim extends EventEmitter {
    connect() {
        setTimeout(
            () =>
                this.emit(
                    "error",
                    new Error("net sockets are fused off in the web build"),
                ),
            0,
        );
        return this;
    }
    write() {
        return false;
    }
    end() {}
    destroy() {}
    setKeepAlive() {
        return this;
    }
    setNoDelay() {
        return this;
    }
    setTimeout() {
        return this;
    }
}

class ServerShim extends EventEmitter {
    listen() {
        setTimeout(
            () =>
                this.emit(
                    "error",
                    new Error("net servers are fused off in the web build"),
                ),
            0,
        );
        return this;
    }
    close(cb) {
        if (typeof cb === "function") setTimeout(cb, 0);
        return this;
    }
    address() {
        return null;
    }
}

module.exports = {
    Socket: SocketShim,
    Server: ServerShim,
    createServer: () => new ServerShim(),
    createConnection: () => new SocketShim().connect(),
    connect: () => new SocketShim().connect(),
    isIP: () => 0,
};
